import { forwardRef } from 'react';

/**
 * Input — labeled text input with error state.
 *
 * Props:
 *   label, hint, error: optional adornments
 *   leadingIcon, trailingIcon: ReactNode slots
 *   ...rest: standard <input> props
 */
const Input = forwardRef(function Input(
  { label, hint, error, leadingIcon, trailingIcon, id, className = '', ...rest },
  ref
) {
  const inputId = id || `in-${(rest.name || Math.random().toString(36).slice(2, 6))}`;
  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      {label && (
        <label htmlFor={inputId} className="font-semibold" style={{ fontSize: 13, color: 'var(--ink)' }}>
          {label}
        </label>
      )}
      <div className="relative flex items-center bg-white"
        style={{
          border: `1px solid ${error ? '#e23a3a' : 'var(--line-2)'}`,
          borderRadius: 10, padding: '0 12px',
        }}>
        {leadingIcon && <span style={{ color: 'var(--muted)' }}>{leadingIcon}</span>}
        <input
          ref={ref}
          id={inputId}
          className="flex-1 outline-none bg-transparent"
          style={{ border: 0, fontFamily: 'inherit', fontSize: 14, padding: '12px 8px', color: 'var(--ink)' }}
          {...rest}
        />
        {trailingIcon && <span style={{ color: 'var(--muted)' }}>{trailingIcon}</span>}
      </div>
      {error && <span style={{ fontSize: 12, color: '#e23a3a' }}>{error}</span>}
      {!error && hint && <span style={{ fontSize: 12, color: 'var(--muted)' }}>{hint}</span>}
    </div>
  );
});

export default Input;
